export function getItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (er) {
    console.error(er);
    return null;
  }
}

export function setItem(key, value, remove) {
  try {
    if (remove) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
    return true;
  } catch (er) {
    console.error(er);
    return false;
  }
}

export function removeItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (er) {
    console.error(er);
    return false;
  }
}

export function clearAll() {
  try {
    const lang = localStorage.getItem("lang");
    localStorage.clear();
    if (lang !== null) {
      localStorage.setItem("lang", lang);
    }
    return true;
  } catch {
    return false;
  }
}
